/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {
  AutoRefreshTokenService,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { ConfigService } from './app/core/services/config.service';
import { environment } from './environments/environment';
import 'moment/locale/de';
import moment from 'moment';

const configService = new ConfigService();

appConfig.providers.push(
  provideKeycloak({
    config: {
      url: environment.api.authUrl,
      realm: environment.api.idp.realm,
      clientId: environment.api.idp.client_id,
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri:
        window.location.origin + '/silent-check-sso.html',
      enableLogging: configService.loggerConfig.idpLogging,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
      }),
    ],
    providers: [AutoRefreshTokenService, UserActivityService],
  }),
);

moment.locale('de');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
